import {Box, styled} from "@mui/material";
import React, {useEffect, useState} from "react";
import backgroundTop from "../../assets/backgroundTop.png";
import {generateCandleData} from "../../helpers/generateCandelasData";
import {activeCandelas} from "./activeCandelas";
import {activeBrain} from "./activiteBrain";

const BrainContainer = styled(Box)({
    height: "calc(100% - 63px)",
    width: "100%",
    position: "absolute",
    bottom: 0
});

const BrainBackground = styled(Box)({
    height: "90vh",
    minHeight: "400px",
    width: "100%",
    bottom: 0,
    position: "absolute",
    background: `url(${backgroundTop}) no-repeat center 100%`,
    backgroundSize: "100%",
    "@media(max-width: 768px)":{
        height: "100%",
        backgroundSize: "230%",
    }
});

const BrainElementCandelas = styled(Box)({
    height: "100%",
    width: "100%",
    position: "absolute",
});

const BrainElement = styled(Box)({
    height: "40vw",
    minHeight: "400px",
    width: "70vw",
    position: "absolute",
    bottom: "6vw",
    left: "15vw",
    "@media(max-width: 768px)":{
        height: "110vw",
        width: "100vw",
        left: 0,
    }
});

const Brain = ():JSX.Element => {
    
    const [candelasGraphData, setCandelasGraphData] = useState<number[][]>([]);
    
    const initCandelas = ():void => {
        setCandelasGraphData(generateCandleData(100));
    };
    
    useEffect(() => {
        initCandelas();
        activeBrain();
    },[]);
    
    useEffect(() => {
        if(candelasGraphData.length){
            activeCandelas(candelasGraphData);
        }
    },[candelasGraphData]);
    
    
    return <BrainContainer>
        <BrainElementCandelas id={"container"}/>
        <BrainBackground/>
        <BrainElement id={"brain"}/>
    </BrainContainer>;
    
    
    
};

export default Brain;
